<app-header></app-header>
<app-loader></app-loader>
<router-outlet></router-outlet>
<app-footer></app-footer>

<app-login *ngIf="shared.fromButtonLogin" [fromButtonLogin]="shared.fromButtonLogin" (onClose)="onClose($event)"></app-login>

<!-- <agm-map [latitude]="lat" [longitude]="lng">
    <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
  </agm-map> -->